import { env } from '@/config/environment';

export const apiEndpoints = {
  enquiry: `${env.API_BASE_URL}/api/enquiry`,
  newsletter: `${env.API_BASE_URL}/api/newsletter`,
} as const;
